import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import logo1 from '../../img/animacionInicial/logo1.png';
import logo2 from '../../img/animacionInicial/logo2.png';
import logo3 from '../../img/animacionInicial/logo3.png';
import logo4 from '../../img/animacionInicial/logo4.png';

const logos = [logo1, logo2, logo3, logo4];
const bgColors = ['#D3DDE9', '#CCFF35', '#A394E5', '#080A26', '#D3DDE9'];
const delays = [600, 500, 400, 400];

const LogoAnimation = () => {
  const containerRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [currentLogo, setCurrentLogo] = useState(logos[0]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      // al inicio bloquear interacción
      container.style.pointerEvents = 'all';
    }

    const runAnimation = (step) => {
      if (step >= bgColors.length) {
        setTimeout(() => {
          if (containerRef.current) {
            containerRef.current.style.opacity = 0;
            containerRef.current.style.transition = 'opacity 0.6s ease';

            // aquí ya terminó la animación → desbloquear interacción
            containerRef.current.style.pointerEvents = 'none';
          }
        }, 200);
        return;
      }

      if (step < logos.length) {
        setCurrentLogo(logos[step]);
        setIndex(step);
      }

      const isLast = step === bgColors.length - 1;
      animateCircle(bgColors[step], isLast);

      setTimeout(() => runAnimation(step + 1), delays[step] || 300);
    };

    const timeout = setTimeout(() => runAnimation(1), delays[0]);

    return () => clearTimeout(timeout);
  }, []);

  const animateCircle = (color, isLast = false) => {
    const container = containerRef.current;
    if (!container) return;

    const circle = document.createElement('div');
    circle.classList.add('circle');
    if (isLast) circle.classList.add('slow');

    circle.style.backgroundColor = color;
    container.appendChild(circle);

    setTimeout(() => {
      container.style.backgroundColor = color;
      circle.remove();
    }, isLast ? 1200 : 600);
  };

  return (
    <div className="animation-container" ref={containerRef}>
      <img
        src={currentLogo}
        alt="Logo"
        className="logo"
        style={{ transform: `scale(${1 + index * 0.3})` }}
      />
    </div>
  );
};

export default LogoAnimation;
